var _defs, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuzzer = function SvgBuzzer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 400 2000 1200"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331 999h1338v514H331Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1512.46c-169.75 0-330.566-31.831-452.824-89.679C407.789 1356.828 331 1263.13 331 1159V999.691c0 27.38 5.293 54.028 15.66 79.649-5.476-13.488-9.52-27.27-12.133-41.309a276 276 0 0 0 12.133 47.559c11.285 32.172 28.559 62.898 51.496 91.75 36.098 45.36 86.2 86.09 149.02 120.351 122.258 66.598 283.074 103.29 452.824 103.29s330.57-36.692 452.82-103.29c62.82-34.261 112.93-74.992 149.02-120.351 22.941-28.852 40.219-59.578 51.5-91.75 5.48-15.55 9.52-31.43 12.129-47.559-2.61 14.04-6.649 27.82-12.13 41.309 10.372-25.621 15.661-52.27 15.661-79.649V1159c0 104.129-76.79 197.828-216.18 263.781-122.25 57.848-283.07 89.68-452.82 89.68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1512.46c-169.75 0-330.566-31.831-452.824-89.679C407.789 1356.828 331 1263.13 331 1159V999.691c0 27.38 5.293 54.028 15.66 79.649-5.476-13.488-9.52-27.27-12.133-41.309a276 276 0 0 0 12.133 47.559c11.285 32.172 28.559 62.898 51.496 91.75 36.098 45.36 86.2 86.09 149.02 120.351 122.258 66.598 283.074 103.29 452.824 103.29s330.57-36.692 452.82-103.29c62.82-34.261 112.93-74.992 149.02-120.351 22.941-28.852 40.219-59.578 51.5-91.75 5.48-15.55 9.52-31.43 12.129-47.559-2.61 14.04-6.649 27.82-12.13 41.309 10.372-25.621 15.661-52.27 15.661-79.649V1159c0 104.129-76.79 197.828-216.18 263.781-122.25 57.848-283.07 89.68-452.82 89.68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331 829h1338v525H331Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1353.191c-169.75 0-330.566-31.87-452.824-89.691-62.82-29.738-112.922-65.102-149.02-104.5-22.937-25.031-40.21-51.719-51.496-79.66-10.367-25.621-15.66-52.27-15.66-79.649 0-61.41 26.703-119.191 77.191-169.78v169.78c0 81.38 66.52 155.04 174.008 208.278 18.063 8.953 37.285 17.32 57.547 25.05q.152.062.305.122h.008c99.726 38.02 224.523 60.609 359.941 60.609 185.531 0 351.129-42.422 459.64-108.8.032-.02.06-.04.098-.06.032-.019.07-.038.102-.062.07-.047.129-.078.191-.117.008-.012.028-.02.04-.02 79.488-48.75 128.23-110.39 131.558-177.652 0-.07 0-.16.012-.23v-.008c0-.082 0-.153.007-.223v-.02c0-.07.012-.136.012-.218v-.02c0-.058.012-.148.012-.21v-.02c0-.078.008-.14.008-.219v-.02c0-.07.011-.152.011-.222v-.008c0-.07.008-.152.008-.223v-.02c0-.077 0-.148.012-.23.008-.468.027-.949.039-1.418v-.03c.012-.071.012-.13.012-.2v-.23c.008-.032.008-.04.008-.07v-.4c.011-.019.011-.05.011-.081v-.379q-.002-.045.008-.09v-.602c0-.027.012-.07.012-.097v-.93c0-.05.008-.09.008-.14V829.91C1642.3 880.5 1669 938.281 1669 999.691c0 27.38-5.29 54.028-15.66 79.649-11.281 27.941-28.559 54.629-51.5 79.66-36.09 39.398-86.2 74.762-149.02 104.5-122.25 57.82-283.07 89.691-452.82 89.691"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1353.191c-169.75 0-330.566-31.87-452.824-89.691-62.82-29.738-112.922-65.102-149.02-104.5-22.937-25.031-40.21-51.719-51.496-79.66-10.367-25.621-15.66-52.27-15.66-79.649 0-61.41 26.703-119.191 77.191-169.78v169.78c0 81.38 66.52 155.04 174.008 208.278 18.063 8.953 37.285 17.32 57.547 25.05q.152.062.305.122h.008c99.726 38.02 224.523 60.609 359.941 60.609 185.531 0 351.129-42.422 459.64-108.8.032-.02.06-.04.098-.06.032-.019.07-.038.102-.062.07-.047.129-.078.191-.117.008-.012.028-.02.04-.02 79.488-48.75 128.23-110.39 131.558-177.652 0-.07 0-.16.012-.23v-.008c0-.082 0-.153.007-.223v-.02c0-.07.012-.136.012-.218v-.02c0-.058.012-.148.012-.21v-.02c0-.078.008-.14.008-.219v-.02c0-.07.011-.152.011-.222v-.008c0-.07.008-.152.008-.223v-.02c0-.077 0-.148.012-.23.008-.468.027-.949.039-1.418v-.03c.012-.071.012-.13.012-.2v-.23c.008-.032.008-.04.008-.07v-.4c.011-.019.011-.05.011-.081v-.379q-.002-.045.008-.09v-.602c0-.027.012-.07.012-.097v-.93c0-.05.008-.09.008-.14V829.91C1642.3 880.5 1669 938.281 1669 999.691c0 27.38-5.29 54.028-15.66 79.649-11.281 27.941-28.559 54.629-51.5 79.66-36.09 39.398-86.2 74.762-149.02 104.5-122.25 57.82-283.07 89.691-452.82 89.691"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408 487h1184v558H408Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1044.422c-160.598 0-306.969-29.512-417.352-77.89-61.793-27.09-112.296-60.102-147.66-97.223a214 214 0 0 0 6.246 9.41c-12.359-17.547-21.46-35.867-26.949-54.77-4.015-13.828-6.094-27.969-6.094-42.347 0-162.403 264.954-294.07 591.809-294.07 326.852 0 591.809 131.667 591.809 294.07 0 14.378-2.079 28.52-6.098 42.347-5.48 18.903-14.59 37.223-26.95 54.781a212 212 0 0 0 6.25-9.421c-35.363 37.12-85.87 70.132-147.66 97.222-110.382 48.38-256.75 77.89-417.351 77.89m0-523.882c-77.621 0-152.84 7.531-223.57 22.402-67.739 14.239-128.371 34.52-180.22 60.278-50.331 25.011-89.491 53.71-116.382 85.312-25.637 30.117-38.637 61.43-38.637 93.07 0 29.977 11.7 59.708 34.77 88.387 5.398 6.711 11.398 13.332 17.969 19.84 173.25-109.86 472.93-243.898 931.5-275.238a528 528 0 0 0-21.64-11.371c-51.849-25.758-112.481-46.04-180.22-60.278-70.73-14.87-145.949-22.402-223.57-22.402"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1044.422c-160.598 0-306.969-29.512-417.352-77.89-61.793-27.09-112.296-60.102-147.66-97.223a214 214 0 0 0 6.246 9.41c-12.359-17.547-21.46-35.867-26.949-54.77-4.015-13.828-6.094-27.969-6.094-42.347 0-162.403 264.954-294.07 591.809-294.07 326.852 0 591.809 131.667 591.809 294.07 0 14.378-2.079 28.52-6.098 42.347-5.48 18.903-14.59 37.223-26.95 54.781a212 212 0 0 0 6.25-9.421c-35.363 37.12-85.87 70.132-147.66 97.222-110.382 48.38-256.75 77.89-417.351 77.89m0-523.882c-77.621 0-152.84 7.531-223.57 22.402-67.739 14.239-128.371 34.52-180.22 60.278-50.331 25.011-89.491 53.71-116.382 85.312-25.637 30.117-38.637 61.43-38.637 93.07 0 29.977 11.7 59.708 34.77 88.387 5.398 6.711 11.398 13.332 17.969 19.84 173.25-109.86 472.93-243.898 931.5-275.238a528 528 0 0 0-21.64-11.371c-51.849-25.758-112.481-46.04-180.22-60.278-70.73-14.87-145.949-22.402-223.57-22.402"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441 520h985v370H441Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.93 889.828c-6.57-6.508-12.57-13.129-17.97-19.84-23.07-28.68-34.769-58.41-34.769-88.386 0-31.641 13-62.954 38.637-93.07 26.89-31.602 66.05-60.302 116.383-85.313 51.848-25.758 112.48-46.04 180.219-60.278 70.73-14.87 145.949-22.402 223.57-22.402s152.84 7.531 223.57 22.402c67.739 14.239 128.371 34.52 180.22 60.278a528 528 0 0 1 21.64 11.37c-458.57 31.34-758.25 165.38-931.5 275.24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.93 889.828c-6.57-6.508-12.57-13.129-17.97-19.84-23.07-28.68-34.769-58.41-34.769-88.386 0-31.641 13-62.954 38.637-93.07 26.89-31.602 66.05-60.302 116.383-85.313 51.848-25.758 112.48-46.04 180.219-60.278 70.73-14.87 145.949-22.402 223.57-22.402s152.84 7.531 223.57 22.402c67.739 14.239 128.371 34.52 180.22 60.278a528 528 0 0 1 21.64 11.37c-458.57 31.34-758.25 165.38-931.5 275.24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434 869h1132v207H434Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1075.672c-92.215 0-179.512-10.492-257.309-29.192-19.144-4.601-37.714-9.699-55.636-15.25a.5.5 0 0 0-.117-.039c-.11-.043-.223-.07-.336-.113-.168-.047-.325-.098-.497-.148-.007 0-.02-.008-.03-.008-29.286-9.121-56.856-19.492-82.4-30.942-.019 0-.042-.011-.062-.02l-.226-.1c-.125-.06-.25-.122-.375-.169-15.438-6.96-30.157-14.312-44.07-22.02-45.79-25.421-82.813-54.812-108.7-87.01a239 239 0 0 1-9.008-11.942 214 214 0 0 1-6.246-9.41c35.364 37.12 85.867 70.132 147.66 97.222 110.383 48.38 256.754 77.89 417.352 77.89 160.602 0 306.969-29.51 417.352-77.89 61.789-27.09 112.296-60.101 147.66-97.222-1.973 3.16-4.063 6.3-6.25 9.421-2.832 4.02-5.84 8-9 11.93-33.75 41.98-86.422 79.18-152.774 109.031-80.097 36.008-180.136 61.297-290.918 71.258a1162 1162 0 0 1-58.28 3.762v.008c-15.759.633-31.712.953-47.79.953"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1075.672c-92.215 0-179.512-10.492-257.309-29.192-19.144-4.601-37.714-9.699-55.636-15.25a.5.5 0 0 0-.117-.039c-.11-.043-.223-.07-.336-.113-.168-.047-.325-.098-.497-.148-.007 0-.02-.008-.03-.008-29.286-9.121-56.856-19.492-82.4-30.942-.019 0-.042-.011-.062-.02l-.226-.1c-.125-.06-.25-.122-.375-.169-15.438-6.96-30.157-14.312-44.07-22.02-45.79-25.421-82.813-54.812-108.7-87.01a239 239 0 0 1-9.008-11.942 214 214 0 0 1-6.246-9.41c35.364 37.12 85.867 70.132 147.66 97.222 110.383 48.38 256.754 77.89 417.352 77.89 160.602 0 306.969-29.51 417.352-77.89 61.789-27.09 112.296-60.101 147.66-97.222-1.973 3.16-4.063 6.3-6.25 9.421-2.832 4.02-5.84 8-9 11.93-33.75 41.98-86.422 79.18-152.774 109.031-80.097 36.008-180.136 61.297-290.918 71.258a1162 1162 0 0 1-58.28 3.762v.008c-15.759.633-31.712.953-47.79.953"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408 781h1184v513H408Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1293.75c-135.418 0-260.215-22.59-359.941-60.61 31.816 12.122 66.183 22.68 102.632 31.43v-218.09c77.797 18.7 165.094 29.192 257.309 29.192 16.078 0 32.031-.32 47.79-.953V1292.8c166.038-6.602 312.75-47.223 411.85-107.852-108.511 66.38-274.109 108.801-459.64 108.801m-359.95-60.61c-.1-.038-.202-.081-.304-.12.102.039.203.082.305.12m-57.852-25.171C474.711 1154.73 408.191 1081.07 408.191 999.69v-218.09c0 14.38 2.079 28.52 6.094 42.348 6.746 23.23 18.953 45.582 35.957 66.711 25.887 32.2 62.91 61.59 108.7 87.012-10.266-5.703-20.098-11.594-29.446-17.684v218.09c16.207 10.55 33.82 20.531 52.703 29.89m877.54-23.077c.03-.02.07-.04.1-.063-.03.024-.07.043-.1.063m.292-.18c.008-.012.028-.02.04-.02-.012 0-.032.008-.04.02m-353.96-113.762c110.78-9.96 210.82-35.25 290.917-71.258 66.352-29.851 119.024-67.05 152.774-109.03 17-21.13 29.207-43.481 35.949-66.712 4.02-13.828 6.098-27.969 6.098-42.347 0 38.52-14.93 75.359-42.047 109.058-33.75 41.98-86.422 79.18-152.774 109.031-80.09 36.008-180.129 61.309-290.918 71.258m-419.468-39.871q-.245-.072-.497-.148c.172.05.329.101.497.148m-.528-.156c-29.289-9.121-56.851-19.48-82.398-30.942 25.543 11.45 53.113 21.82 82.398 30.942m905.567-24.113v-.008zm.007-.23v-.02zm.012-.24v-.019zm.012-.23v-.02zm.008-.239v-.02zm.011-.242v-.008zm.008-.23v-.02zm.012-.25c0-.008 0 .011 0 0m.039-1.419v-.03zm.012-.23v-.059zm0-.23c.008-.032.008-.04.008-.07 0 .03 0 .038-.008.07m.008-.23v-.08zm0-.24c.011-.019.011-.05.011-.081 0 .031 0 .062-.011.082m.011-.223v-.098zm0-.238q-.002-.045.008-.09-.01.045-.008.09m.008-.23v-.098zm0-.23v-.098zm0-.23c0-.028.012-.079.012-.098 0 .027-.012.07-.012.097m.012-.226v-.113zm0-.23v-.114zm0-.242v-.097zm0-.23v-.098zm.008-.239v-.101zm0-.242v-.09zm0-.25v-.066zm-988.196-.027a2 2 0 0 0-.226-.102z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 1293.75c-135.418 0-260.215-22.59-359.941-60.61 31.816 12.122 66.183 22.68 102.632 31.43v-218.09c77.797 18.7 165.094 29.192 257.309 29.192 16.078 0 32.031-.32 47.79-.953V1292.8c166.038-6.602 312.75-47.223 411.85-107.852-108.511 66.38-274.109 108.801-459.64 108.801m-359.95-60.61c-.1-.038-.202-.081-.304-.12.102.039.203.082.305.12m-57.852-25.171C474.711 1154.73 408.191 1081.07 408.191 999.69v-218.09c0 14.38 2.079 28.52 6.094 42.348 6.746 23.23 18.953 45.582 35.957 66.711 25.887 32.2 62.91 61.59 108.7 87.012-10.266-5.703-20.098-11.594-29.446-17.684v218.09c16.207 10.55 33.82 20.531 52.703 29.89m877.54-23.077c.03-.02.07-.04.1-.063-.03.024-.07.043-.1.063m.292-.18c.008-.012.028-.02.04-.02-.012 0-.032.008-.04.02m-353.96-113.762c110.78-9.96 210.82-35.25 290.917-71.258 66.352-29.851 119.024-67.05 152.774-109.03 17-21.13 29.207-43.481 35.949-66.712 4.02-13.828 6.098-27.969 6.098-42.347 0 38.52-14.93 75.359-42.047 109.058-33.75 41.98-86.422 79.18-152.774 109.031-80.09 36.008-180.129 61.309-290.918 71.258m-419.468-39.871q-.245-.072-.497-.148c.172.05.329.101.497.148m-.528-.156c-29.289-9.121-56.851-19.48-82.398-30.942 25.543 11.45 53.113 21.82 82.398 30.942m905.567-24.113v-.008zm.007-.23v-.02zm.012-.24v-.019zm.012-.23v-.02zm.008-.239v-.02zm.011-.242v-.008zm.008-.23v-.02zm.012-.25c0-.008 0 .011 0 0m.039-1.419v-.03zm.012-.23v-.059zm0-.23c.008-.032.008-.04.008-.07 0 .03 0 .038-.008.07m.008-.23v-.08zm0-.24c.011-.019.011-.05.011-.081 0 .031 0 .062-.011.082m.011-.223v-.098zm0-.238q-.002-.045.008-.09-.01.045-.008.09m.008-.23v-.098zm0-.23v-.098zm0-.23c0-.028.012-.079.012-.098 0 .027-.012.07-.012.097m.012-.226v-.113zm0-.23v-.114zm0-.242v-.097zm0-.23v-.098zm.008-.239v-.101zm0-.242v-.09zm0-.25v-.066zm-988.196-.027a2 2 0 0 0-.226-.102z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582 1207h59v27h-59Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.059 1233.14h-.008zm-.313-.12c-20.262-7.73-39.484-16.098-57.547-25.051 18.07 8.953 37.281 17.312 57.547 25.05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.059 1233.14h-.008zm-.313-.12c-20.262-7.73-39.484-16.098-57.547-25.051 18.07 8.953 37.281 17.312 57.547 25.05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687 1031h56v16h-56Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.691 1046.48c-19.144-4.601-37.707-9.69-55.636-15.25 17.922 5.551 36.492 10.649 55.636 15.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.691 1046.48c-19.144-4.601-37.707-9.69-55.636-15.25 17.922 5.551 36.492 10.649 55.636 15.25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686 1031h1v1h-1Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.938 1031.191c-.11-.043-.223-.07-.336-.113.113.043.226.07.336.113"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.938 1031.191c-.11-.043-.223-.07-.336-.113.113.043.226.07.336.113"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686 1030h1v1h-1Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.105 1030.93c-.003 0-.023-.008-.03-.008.01 0 .023.008.03.008"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.105 1030.93c-.003 0-.023-.008-.03-.008.01 0 .023.008.03.008"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603 999h1v1h-1Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.676 999.98c-.028-.011-.035-.011-.063-.02.02.009.043.02.063.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.676 999.98c-.028-.011-.035-.011-.063-.02.02.009.043.02.063.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603 999h1v1h-1Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.387 999.86c-.13-.06-.246-.122-.375-.169.125.047.25.11.375.168"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.387 999.86c-.13-.06-.246-.122-.375-.169.125.047.25.11.375.168"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558 977h46v23h-46Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.012 999.691c-15.453-6.953-30.164-14.312-44.07-22.02 13.913 7.708 28.632 15.06 44.07 22.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.012 999.691c-15.453-6.953-30.164-14.312-44.07-22.02 13.913 7.708 28.632 15.06 44.07 22.02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529 959h214v306H529Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.691 1264.57c-36.449-8.75-70.816-19.308-102.632-31.43h-.008c-.102-.038-.203-.081-.305-.12-20.266-7.739-39.476-16.098-57.547-25.051-18.883-9.36-36.496-19.34-52.703-29.89v-218.09c9.348 6.09 19.18 11.98 29.445 17.683 13.907 7.707 28.618 15.066 44.07 22.02.13.046.247.109.376.167.078.032.152.063.226.102.028.008.035.008.063.02 25.547 11.46 53.11 21.82 82.398 30.94.008 0 .028.009.031.009q.25.076.497.148c.113.043.226.07.336.113.039.008.074.02.117.04 17.93 5.558 36.492 10.648 55.636 15.25z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.691 1264.57c-36.449-8.75-70.816-19.308-102.632-31.43h-.008c-.102-.038-.203-.081-.305-.12-20.266-7.739-39.476-16.098-57.547-25.051-18.883-9.36-36.496-19.34-52.703-29.89v-218.09c9.348 6.09 19.18 11.98 29.445 17.683 13.907 7.707 28.618 15.066 44.07 22.02.13.046.247.109.376.167.078.032.152.063.226.102.028.008.035.008.063.02 25.547 11.46 53.11 21.82 82.398 30.94.008 0 .028.009.031.009q.25.076.497.148c.113.043.226.07.336.113.039.008.074.02.117.04 17.93 5.558 36.492 10.648 55.636 15.25z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1459 1007h133v178h-133Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1459.64 1184.95c.032-.02.06-.04.098-.06-.039.02-.066.04-.097.06m.199-.122a3 3 0 0 1 .191-.117c-.062.039-.12.07-.191.117m.23-.137c79.489-48.761 128.239-110.402 131.559-177.652-3.328 67.262-52.07 128.902-131.559 177.652"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1459.64 1184.95c.032-.02.06-.04.098-.06-.039.02-.066.04-.097.06m.199-.122a3 3 0 0 1 .191-.117c-.062.039-.12.07-.191.117m.23-.137c79.489-48.761 128.239-110.402 131.559-177.652-3.328 67.262-52.07 128.902-131.559 177.652"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1047 1070h60v5h-60Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1047.79 1074.719v-.008a1162 1162 0 0 0 58.28-3.762 1159 1159 0 0 1-58.28 3.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1047.79 1074.719v-.008a1162 1162 0 0 0 58.28-3.762 1159 1159 0 0 1-58.28 3.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591 999h1v9h-1Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591.629 1007.04c0-.08 0-.15.012-.231-.012.07-.012.16-.012.23m.012-.238c0-.082 0-.14.007-.223-.007.07-.007.14-.007.223m.007-.242c0-.079.012-.137.012-.22 0 .083-.012.15-.012.22m.012-.239c0-.082.012-.129.012-.21 0 .062-.012.152-.012.21m.012-.23c0-.07.008-.149.008-.219 0 .078-.008.14-.008.219m.008-.238c0-.082.011-.141.011-.223 0 .07-.011.152-.011.223m.011-.23c0-.071.008-.153.008-.224 0 .07-.008.153-.008.223m.008-.242c0-.078 0-.149.012-.23-.012.081-.012.152-.012.23m.012-.23c.008-.477.027-.95.039-1.419-.012.47-.031.95-.04 1.418m.04-1.449c.012-.07.012-.129.012-.199 0 .07 0 .129-.012.2m.012-.259v-.171zm.008-.242v-.16zm0-.238v-.16zm.011-.242v-.14zm0-.239v-.14zm.008-.23v-.14zm0-.238v-.133zm0-.23v-.134zm.012-.23v-.13zm0-.242v-.118zm0-.23v-.13zm0-.227v-.133zm0-.23c0-.044.008-.102.008-.142 0 .051-.008.09-.008.141m.008-.242v-.14zm0-.23v-.16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1591.629 1007.04c0-.08 0-.15.012-.231-.012.07-.012.16-.012.23m.012-.238c0-.082 0-.14.007-.223-.007.07-.007.14-.007.223m.007-.242c0-.079.012-.137.012-.22 0 .083-.012.15-.012.22m.012-.239c0-.082.012-.129.012-.21 0 .062-.012.152-.012.21m.012-.23c0-.07.008-.149.008-.219 0 .078-.008.14-.008.219m.008-.238c0-.082.011-.141.011-.223 0 .07-.011.152-.011.223m.011-.23c0-.071.008-.153.008-.224 0 .07-.008.153-.008.223m.008-.242c0-.078 0-.149.012-.23-.012.081-.012.152-.012.23m.012-.23c.008-.477.027-.95.039-1.419-.012.47-.031.95-.04 1.418m.04-1.449c.012-.07.012-.129.012-.199 0 .07 0 .129-.012.2m.012-.259v-.171zm.008-.242v-.16zm0-.238v-.16zm.011-.242v-.14zm0-.239v-.14zm.008-.23v-.14zm0-.238v-.133zm0-.23v-.134zm.012-.23v-.13zm0-.242v-.118zm0-.23v-.13zm0-.227v-.133zm0-.23c0-.044.008-.102.008-.142 0 .051-.008.09-.008.141m.008-.242v-.14zm0-.23v-.16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1047 781h545v512h-545Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1047.79 1292.8V1074.72c19.71-.778 39.16-2.047 58.28-3.77 110.79-9.949 210.828-35.25 290.918-71.258 66.352-29.851 119.024-67.05 152.774-109.03 27.117-33.7 42.047-70.54 42.047-109.06v218.879c0 .04-.008.098-.008.141v.93c0 .02-.012.07-.012.097v.602q-.01.045-.008.09v.378c0 .032 0 .063-.011.083v.398c0 .031 0 .04-.008.07v.231c0 .07 0 .129-.012.2v.03c-.012.47-.031.942-.04 1.418 0 .012 0-.007 0 0-.01.082-.01.153-.01.23v.02c0 .07-.009.153-.009.223v.008c0 .082-.011.14-.011.223v.02c0 .07-.008.148-.008.218v.02c0 .081-.012.128-.012.21v.02c0 .082-.012.14-.012.219v.02c-.007.081-.007.14-.007.222v.008c-.012.082-.012.152-.012.23-3.32 67.25-52.07 128.89-131.559 177.652-.011 0-.03.008-.039.02-.07.039-.12.07-.191.117-.031.024-.07.043-.102.063-.039.02-.066.039-.097.058-99.102 60.63-245.813 101.25-411.852 107.852"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Buzzer_svg__am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1047.79 1292.8V1074.72c19.71-.778 39.16-2.047 58.28-3.77 110.79-9.949 210.828-35.25 290.918-71.258 66.352-29.851 119.024-67.05 152.774-109.03 27.117-33.7 42.047-70.54 42.047-109.06v218.879c0 .04-.008.098-.008.141v.93c0 .02-.012.07-.012.097v.602q-.01.045-.008.09v.378c0 .032 0 .063-.011.083v.398c0 .031 0 .04-.008.07v.231c0 .07 0 .129-.012.2v.03c-.012.47-.031.942-.04 1.418 0 .012 0-.007 0 0-.01.082-.01.153-.01.23v.02c0 .07-.009.153-.009.223v.008c0 .082-.011.14-.011.223v.02c0 .07-.008.148-.008.218v.02c0 .081-.012.128-.012.21v.02c0 .082-.012.14-.012.219v.02c-.007.081-.007.14-.007.222v.008c-.012.082-.012.152-.012.23-3.32 67.25-52.07 128.89-131.559 177.652-.011 0-.03.008-.039.02-.07.039-.12.07-.191.117-.031.024-.07.043-.102.063-.039.02-.066.039-.097.058-99.102 60.63-245.813 101.25-411.852 107.852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__d",
    x1: -0.033,
    x2: 1.049,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 814.285 628.04)scale(1236.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#222121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#232222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#242323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#242423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#252424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#262524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#262525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#272625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#272626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#282726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#282726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#292827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#292827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#2B2928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#2B2928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#2C2A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#2C2A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#2D2B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#2D2B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#2E2C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2E2C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#2F2D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#302D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#302E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#312E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#312F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#322F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#322F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#33302E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#33302F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#34312F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#35312F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#353230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#363230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#363331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#373331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#373431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#383432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#393532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#393533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#3A3633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#3A3633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#3B3634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#3B3734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#3C3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#3C3835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#3D3836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#3E3936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#3E3936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__h",
    x1: -0.033,
    x2: 1.049,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 814.285 499.855)scale(1236.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#222121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#232222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#242323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#242423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#252424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#262524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#262525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#272625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#272626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#282726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#282726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#292827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#292827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2A2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#2B2928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#2B2928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#2C2A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#2C2A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#2D2B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#2D2B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#2E2C2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2E2C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#2F2D2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#302D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#302E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#312E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#312F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#322F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#322F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#33302E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#33302F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#34312F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#35312F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#353230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#363230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#363331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#373331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#373431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#383432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#393532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#393533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#3A3633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#3A3633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#3B3634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#3B3734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#3C3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#3C3835"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#3D3836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#3E3936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#3E3936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__l",
    x1: -0.26,
    x2: 1.253,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(22.526 -1244.96 1809.852)scale(863.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FE0E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FE0E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#FE0E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#FE0E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FE0E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#FD0E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#FD0F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FC0F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#FB0F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#FB0F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#FA0F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#FA1027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#F91027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F91027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#F81027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#F81027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#F71127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#F61127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#F61127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#F51127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#F51227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#F41227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F41227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#F31227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#F31227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#F21327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#F11327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#F11327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#F01327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F01327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#EF1427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#EF1427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#EE1427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#EE1427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#ED1427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EC1527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#EC1527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#EB1527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#EB1527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#EA1627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#EA1627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#E91627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#E91627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#E81627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#E71727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E71727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#E61727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#E61727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#E51727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#E51827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#E41827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#E41827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#E31827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#E21927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E21927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#E11927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#E11927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#E01927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#E01A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#DF1A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#DF1A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#DE1A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#DD1A27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#DD1B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#DC1B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#DC1B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#DB1B27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#DB1C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DA1C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#DA1C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#D91C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D81C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#D81D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#D71D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D71D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#D61D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#D61D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D51E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#D51E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#D41E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#D31E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#D31E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#D21F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#D21F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#D11F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#D11F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D02027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#D02027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#CF2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#CF2027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF2027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__p",
    x1: -0.21,
    x2: 1.007,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(22.526 -1244.96 1809.852)scale(863.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FF7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#FF7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#FF7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#FF7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FE7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#FE7165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FE7165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#FE7165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#FE7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FE7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#FE7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#FE7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#FD7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#FD7365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#FD7365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FD7465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#FD7465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FD7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#FC7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FC7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#FC7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#FC7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#FC7665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#FC7665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#FC7665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#FC7665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FC7765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#FB7765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#FB7765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#FB7865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#FB7865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#FB7965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FB7965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#FB7965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#FB7965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#FB7A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#FA7A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__t",
    x1: -0.062,
    x2: 1.238,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(22.526 -1244.96 1809.852)scale(863.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#FF7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FF7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#FF7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#FE7065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FE7165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#FE7165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FE7165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#FE7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FE7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FE7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#FE7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FD7265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#FD7365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FD7365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#FD7465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FD7465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#FD7465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#FD7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#FC7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#FC7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#FC7565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FC7665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#FC7665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FC7665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#FC7765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FB7765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#FB7865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#FB7865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#FB7965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#FB7965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FB7965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#FB7A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#FA7A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#FA7A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#FA7B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FA7B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA7B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__x",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "translate(408.192 1037.68)scale(1183.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DD0A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#DD0A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#DC0A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#DB0A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#DB0B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#DA0B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#D90B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#D90B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#D80B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#D70B18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#D60B18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#D60C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#D50C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#D40C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#D40C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D30C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#D20C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#D20D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#D10D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#D00D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#CF0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#CF0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#CE0D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#CD0E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#CD0E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#CC0E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#CB0E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#CB0E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#CA0E1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#C90F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#C80F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C80F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#C70F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#C60F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#C60F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#C50F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#C41020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#C41020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#C31020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#C21021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#C11021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#C11021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#C01122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#BF1122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#BF1122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#BE1122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#BD1123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BD1123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#BC1223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#BB1224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#BA1224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#BA1224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#B91225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#B81225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#B81225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#B71325"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#B61326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#B61326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#B51326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#B41327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#B31327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#B31427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    stopColor: "#B21428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B11428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__B",
    x1: 0.799,
    x2: 0.846,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 814.285 499.855)scale(1236.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EB876D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EB876D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB876E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB886E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__F",
    x1: 0.28,
    x2: 0.346,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(22.526 -1244.96 1809.852)scale(863.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFAB92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFAB92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__Y",
    x1: 0.102,
    x2: 0.283,
    y1: 0,
    y2: 0,
    gradientTransform: "translate(408.192 1037.68)scale(1183.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FB6E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FB6E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FB6E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FB6F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FB6F5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FB6F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6F5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__ac",
    x1: 0.03,
    x2: 0.137,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(180 814.285 499.855)scale(1236.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1B1616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1B1616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B1616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1716"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__ag",
    x1: 0.683,
    x2: 0.747,
    y1: 0,
    y2: 0,
    gradientTransform: "rotate(22.526 -1244.96 1809.852)scale(863.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#CF4F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CF5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CE5043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE5043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Buzzer_svg__an",
    x1: 0.54,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "translate(408.192 1037.68)scale(1183.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A10A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#A10A15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#A10B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#A10B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#A00B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#9F0B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#9F0B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#9E0B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9E0B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#9D0B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#9C0B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#9C0B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#9B0B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#9A0B17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#990C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#990C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#980C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#970C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#970C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#960D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#960D19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#950D19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#940D19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#940D19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#940D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#930D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#920D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#920D1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#910D1A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__d)",
    d: "M1669 1512.46V999.692H331v512.77Zm0 0"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AD9D97",
    d: "M1665.469 1038.031a275 275 0 0 1-12.13 47.559c-11.28 32.172-28.558 62.898-51.5 91.75-36.089 45.36-86.198 86.09-149.019 120.351-122.25 66.598-283.07 103.29-452.82 103.29s-330.566-36.692-452.824-103.29c-62.82-34.261-112.922-74.992-149.02-120.351-22.937-28.852-40.21-59.578-51.496-91.75a276 276 0 0 1-12.133-47.559c2.614 14.04 6.657 27.82 12.133 41.309 11.285 27.941 28.559 54.629 51.496 79.66 36.098 39.398 86.2 74.762 149.02 104.5 122.258 57.82 283.074 89.691 452.824 89.691s330.57-31.87 452.82-89.691c62.82-29.738 112.93-65.102 149.02-104.5 22.941-25.031 40.219-51.719 51.5-79.66 5.48-13.488 9.52-27.27 12.129-41.309"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__h)",
    d: "M1669 1353.191v-523.28H331v523.28Zm0 0"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__l)",
    d: "M581.91 68.676 211.121 962.688l1206.973 500.585 370.785-894.007Zm0 0"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__m)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__n)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__p)",
    d: "M585.645 172.242 310.508 835.63l970.469 402.5 275.136-663.39Zm0 0"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__q)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__r)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__t)",
    d: "m600.84 469.426-238.875 575.957 1037.195 430.172 238.875-575.957Zm0 0"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__u)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__v)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__x)",
    d: "M408.191 781.602v512.148H1591.81V781.602Zm0 0"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__y)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__B)",
    d: "M640.059 1233.14v-25.171h-57.86v25.172Zm0 0"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__C)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__D)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__F)",
    d: "m695.219 1011.543-13.563 32.7 52.871 21.925 13.563-32.7Zm0 0"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__G)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__H)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__I)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB92",
    d: "m686.652 1030.96-.09.216.325.133.09-.211Zm0 0"
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__J)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__K)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAB92",
    d: "m686.078 1030.91-.008.02.032.011.007-.02Zm0 0"
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__M)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__N)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__O)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAA92",
    d: "m603.621 999.938-.016.039.063.023.016-.035Zm0 0"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__P)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__Q)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__R)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAA92",
    d: "m603.066 999.559-.117.277.383.156.113-.277Zm0 0"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__S)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__T)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAA92",
    d: "m565.41 962.074-14.258 34.383 45.391 18.828 14.262-34.383Zm0 0"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__V)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__W)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__X)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__Y)",
    d: "M529.496 959.988v304.582h213.195V959.988Zm0 0"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__Z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__ac)",
    d: "M1591.629 1184.95v-177.91H1459.64v177.91Zm0 0"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__ad)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__ae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__ag)",
    d: "m1056.344 1050.328-9.887 23.84 51.059 21.176 9.886-23.84Zm0 0"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__ah)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__ai)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__aj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1B1616",
    d: "M1591.809 1007.04v-7.052h-.18v7.051Zm0 0"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__ak)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__al)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Buzzer_svg__am)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Buzzer_svg__an)",
    d: "M1047.79 781.602V1292.8h544.019V781.6Zm0 0"
  }))))));
};
export default SvgBuzzer;